<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
        <iq-card>
                <template v-slot:body>
                    <b-overlay :show="unitload">
                    <template>
                                <div style="font-size:18px; background-color: #005B5B; text-align: center;">
                                    <h5 class="text-white">
                                        {{ $t('social_service.rehabilitation_title') }}
                                    </h5>
                                </div>
                            </template>
                        <b-row>
                            <b-col xl="12" lg="12" sm="12">
                                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                    <b-form @submit.prevent="handleSubmit(storeUpdateData)" @reset.prevent="reset" enctype="multipart/form-data">
<b-row>
  <b-col lg="3" sm="3">
    <ValidationProvider name="Area Type" vid="hos_area_type_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="hos_area_type_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro.area_type')}}
        </template>
        <b-form-select
          plain
          v-model="rehabilitation.hos_area_type_id"
          id="hos_area_type_id"
          :options="getHosAreaTypeList"
          :disabled="isDisable"
          @change="getAreaTypeData(rehabilitation.area_type_id)"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3">
    <ValidationProvider name="Division" vid="division_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="division_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('externalUser.division')}}
        </template>
        <b-form-select
          plain
          v-model="rehabilitation.hos_division_id"
          id="division_id"
          :options="getHosDivisionList"
          :disabled="isDisable"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3">
    <ValidationProvider name="District" vid="district_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="district_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro_district.district')}}
        </template>
        <b-form-select
          plain
          v-model="rehabilitation.hos_district_id"
          id="district_id"
          :options="getHosDistrictList"
          :disabled="isDisable"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3" v-if="rehabilitation.hos_area_type_id > 1">
    <ValidationProvider name="Upazila" vid="upazila_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="upazila_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro_upazilla.upazilla')}}
        </template>
        <b-form-select
          plain
          v-model="rehabilitation.hos_upazila_id"
          id="upazila_id"
          :options="getHosUpazillaList"
          :disabled="isDisable"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3" v-if="rehabilitation.hos_area_type_id === 1">
    <ValidationProvider name="City Corporation" vid="city_corporation_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="city_corporation_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro.city_corporation')}}
        </template>
        <b-form-select
          plain
          v-model="rehabilitation.hos_city_corporation_id"
          id="city_corporation_id"
          :options="getHosCityCorporationList"
          :disabled="isDisable"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="9" sm="9">
    <ValidationProvider name="Hospital Name" vid="hospital_id" rules="required">
      <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="hospital_id"
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{ $t('hospital_configuration.hospital_name')}}<span class="text-danger">*</span>
        </template>
        <v-select name="Bank"
            v-model="rehabilitation.hospital_id"
            label="text"
            :reduce="item => item.value"
            :options= hospitalList
            :placeholder="$t('globalTrans.select')"
        />
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
      </b-form-group>
    </ValidationProvider>
  </b-col>
    <b-col lg="3"  sm="12">
        <ValidationProvider name="Patient Type" vid="patient_type" rules="required|min_value:1">
            <b-form-group
                class="row"
                label-cols-sm="12"
                label-for="patient_type"
                slot-scope="{ valid, errors }"
                >
                <template v-slot:label>
                {{$t('social_service.patient_type')}} <span class="text-danger">*</span>
                </template>
                <b-form-select
                plain
                v-model="rehabilitation.patient_type"
                :options="patientTypeList"
                id="patient_type"
                :state="errors[0] ? false : (valid ? true : null)"
                >
                <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                </template>
                </b-form-select>
                <div class="invalid-feedback">
                {{ errors[0] }}
                </div>
            </b-form-group>
        </ValidationProvider>
    </b-col>
</b-row>                                        <b-row class="mt-2">
                                       <!--     <b-col lg="6" sm="12">
                                                <ValidationProvider name="Hopital Nmae" vid="hospital_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="6"
                                                        label-for="hospital_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('hospital_configuration.hos_name')}}<span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="rehabilitation.hospital_id"
                                                        :options="hospitalList"
                                                        id="hospital_id"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                    </ValidationProvider>
                                            </b-col>-->
                                            <b-col lg="12"  sm="12">
                                                <iq-card style="border: 0.5px solid #efeefd;padding: 15px 0px 0px 0px;border-radius: 0px;">
                                                    <b-row>
                                                        <b-col cols="6">
                                                            <ValidationProvider name="Form No" vid="auto_id" rules="required|min_value:1">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="6"
                                                                    label-for="auto_id"
                                                                    slot-scope="{ valid, errors }"
                                                                    >
                                                                    <template v-slot:label>
                                                                        <span style="">{{$t('hospital_information.form_no')}}</span><span class="text-danger">*</span>
                                                                    </template>
                                                                    <b-form-input
                                                                    id="auto_id"
                                                                    v-model="rehabilitation.auto_id"
                                                                    :readonly="form_no_disabled"
                                                                    @blur="searchFormNoData"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    ></b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                    <span class="text-danger" v-if="rehabilitation.hospital_id === ''">Choose a Hospital</span>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                        <b-col cols="6" hidden>
                                                            <ValidationProvider name="Form No" vid="form_no" rules="required|min_value:1">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="6"
                                                                    label-for="form_no"
                                                                    slot-scope="{ valid, errors }"
                                                                    >
                                                                    <template v-slot:label>
                                                                        <span style="">{{$t('hospital_information.form_no')}}</span><span class="text-danger">*</span>
                                                                    </template>
                                                                    <b-form-input
                                                                    id="form_no"
                                                                    v-model="rehabilitation.form_no"
                                                                    :readonly="form_no_disabled"
                                                                    @blur="searchFormNoData"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    ></b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                        <!-- <b-col v-if="isShow" cols="6">
                                                            <b-button type="button" variant="primary" @click="searchFormNoData">{{ $t('globalTrans.search')}}</b-button>
                                                        </b-col> -->
                                                    </b-row>
                                                </iq-card>
                                            </b-col>
                                            <b-col lg="6"  sm="12">
                                                <ValidationProvider name="Patient Name (Bn)" vid="patient_name_bn" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="6"
                                                        label-for="patient_name_bn"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('social_service.patient_nam_bn')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                            id="patient_name_bn"
                                                            v-model="rehabilitation.patient_name_bn"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                             <b-col lg="6"  sm="12">
                                                <ValidationProvider name="Patient Name (En)" vid="patient_name" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="6"
                                                        label-for="patient_name"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('social_service.patient_nam_en')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                            id="patient_name"
                                                            v-model="rehabilitation.patient_name"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6"  sm="12">
                                                <ValidationProvider name="Age" vid="age" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="6"
                                                        label-for="age"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('social_service.age')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                            id="age"
                                                            v-model="rehabilitation.age"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6"  sm="12">
                                                <ValidationProvider name="Gender" vid="gender_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="6"
                                                        label-for="gender_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{ $t('hospital_information.gender')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                            plain
                                                            v-model="rehabilitation.gender_id"
                                                            :options="genderList"
                                                            id="gender_id"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                        </b-row>
                                        <iq-card>
                                            <template>
                                                <div style="font-size:18px; background-color: #005B5B; text-align: center;">
                                                    <h5 class="text-white">
                                                        {{ $t('social_service.patient_addres') }}
                                                    </h5>
                                                </div>
                                            </template>
                                            <div class="card-body iq-card-body card-address">
                                            <b-container fluid bg-variant="primary" class="border border-success"><br>
                                                <b-row>
                                                <b-col lg="4" sm="4">
                                                    <ValidationProvider name="Area Type" vid="area_type_id"  rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="area_type_id "
                                                            slot-scope="{ valid, errors }"
                                                            >
                                                            <template v-slot:label>
                                                                {{$t('org_pro.area_type')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                            plain
                                                            v-model="rehabilitation.area_type_id"
                                                            id="area_type_id"
                                                            :options="getAreaTypeList"
                                                            @change="getAreaTypeData(rehabilitation.area_type_id)"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            <template v-slot:first>
                                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                            </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="4" sm="4">
                                                    <ValidationProvider name="Division" vid="division_id"  rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="division_id"
                                                            slot-scope="{ valid, errors }"
                                                            >
                                                            <template v-slot:label>
                                                            {{ $t('org_pro_division.division')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                            plain
                                                            v-model="rehabilitation.division_id"
                                                            :options="divisionList"
                                                            id="division_id"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            <template v-slot:first>
                                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                            </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="4" sm="4">
                                                    <ValidationProvider name="District" vid="district_id"  rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="district_id"
                                                            slot-scope="{ valid, errors }"
                                                            >
                                                            <template v-slot:label>
                                                            {{ $t('org_pro_district.district')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                            plain
                                                            v-model="rehabilitation.district_id"
                                                            :options="districtList"
                                                            id="district_id"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            <template v-slot:first>
                                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                            </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                </b-row>
                                                <b-row>
                                                <b-col lg="4" sm="4" v-if="PauroshobaItemShow || UnionItemShow">
                                                        <ValidationProvider name="Upazila" vid="upazila_id" v-if="PauroshobaItemShow || UnionItemShow">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="5"
                                                                label-for="upazila_id"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{ $t('org_pro_upazilla.upazilla')}} <span class="text-danger">*</span>
                                                                </template>
                                                                <b-form-select
                                                                plain
                                                                v-model="rehabilitation.upazilla_id"
                                                                :options="upazilaList"
                                                                id="upazila_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                                </b-form-select>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="4" sm="4" v-if="UnionItemShow" >
                                                        <ValidationProvider name="Union" vid="union_id" v-if="UnionItemShow">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="5"
                                                                label-for="union_id"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{ $t('org_pro_union.union')}}
                                                                </template>
                                                                <b-form-select
                                                                plain
                                                                v-model="rehabilitation.union_id"
                                                                :options="unionList"
                                                                id="union_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                                </b-form-select>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="4" sm="4" v-if="CityCorpItemShow" >
                                                        <ValidationProvider name="City Corporation" vid="city_corporation_id" v-if="CityCorpItemShow">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="5"
                                                                label-for="city_corporation_id"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                    {{ $t('org_pro.city_corporation') }}
                                                                </template>
                                                                <b-form-select
                                                                plain
                                                                v-model="rehabilitation.city_corporation_id"
                                                                :options="cityCorporationList"
                                                                id="city_corporation_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                                </b-form-select>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="4" sm="4" v-if="PauroshobaItemShow" >
                                                        <ValidationProvider name="Municipality" vid="pauroshoba_id">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="5"
                                                                label-for="pauroshoba_id"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                    {{ $t('org_pro.pauroshoba') }}
                                                                </template>
                                                                <b-form-select
                                                                plain
                                                                v-model="rehabilitation.pauroshoba_id"
                                                                :options="pauroshobaList"
                                                                id="pauroshoba_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                                </b-form-select>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="4" sm="4" v-if="ItemShow">
                                                        <ValidationProvider name="Ward" vid="ward_id">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="5"
                                                                label-for="ward_id"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                    {{ $t('org_pro.ward') }}
                                                                </template>
                                                                <b-form-select
                                                                plain
                                                                v-model="rehabilitation.ward_id"
                                                                :options="wardList"
                                                                id="ward_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                                </b-form-select>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                <b-col lg="6" sm="6">
                                                <ValidationProvider name="Address (Bn)" vid="address_bn" rules="required">
                                                    <b-form-group
                                                    class="row"
                                                    label-cols-sm="12"
                                                    label-for="address_bn"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{ $t('hospital_information.address_bn')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-textarea
                                                        id="address_bn"
                                                        v-model="rehabilitation.address_bn"
                                                        rows = "4"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-textarea>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                <ValidationProvider name="Address" vid="address" rules="required">
                                                    <b-form-group
                                                    class="row"
                                                    label-cols-sm="12"
                                                    label-for="address"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{ $t('hospital_information.address_en')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-textarea
                                                        id="address"
                                                        v-model="rehabilitation.address"
                                                        rows = "4"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-textarea>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                                </b-col>
                                                </b-row>
                                            </b-container>
                                            </div>
                                        </iq-card>
                                        <b-row>
                                            <b-col>
                                                <!-- <h5 style="background-color: #66cc99;margin-bottom: 15px;color: white;padding: 8px 8px 8px 8px;">{{ $t('social_service.other_info') }}</h5> -->
                                                <template>
                                                    <div style="font-size:18px; background-color: #005B5B; text-align: center;">
                                                        <h5 class="text-white">
                                                            {{ $t('social_service.other_infos') }}
                                                        </h5>
                                                    </div>
                                                </template><br>
                                                <div style="font-size:16px; margin-bottom:5px;" class="bg-gray">
                                                <h5 class="text-dark text-center mb-2"> {{ $t('social_service.other_infos2') }}</h5>
                                                </div><br>
                                                <b-row>
                                                    <b-col lg="6"  sm="12">
                                                        <ValidationProvider name="Category" vid="patient_category" rules="required|min_value:1">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="6"
                                                                label-for="patient_category"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{ $t('social_service.categorys')}} <span class="text-danger">*</span>
                                                                </template>
                                                                <b-form-select
                                                                    plain
                                                                    v-model="rehabilitation.patient_category"
                                                                    :options="socialServiceDeliveryList"
                                                                    id="patient_category"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                                </b-form-select>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="6"  sm="12">
                                                        <ValidationProvider name="Category" vid="patient_category" rules="required|min_value:1">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="6"
                                                                label-for="patient_category"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{ $t('social_service.rehab_institute')}} <span class="text-danger">*</span>
                                                                </template>
                                                                <b-form-select
                                                                    plain
                                                                    v-model="rehabilitation.rehab_institute_id"
                                                                    :options="rehabilitationInstituteList"
                                                                    id="patient_category"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                                </b-form-select>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="6"  sm="12" v-if="rehabilitation.rehab_institute_id === 5">
                                                        <ValidationProvider name="other_description" vid="other_description">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="6"
                                                                label-for="other_description"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('globalTrans.other')}}
                                                                </template>
                                                                <b-form-input
                                                                    id="other_description"
                                                                    v-model="rehabilitation.other_description"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                ></b-form-input>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="6"  sm="12">
                                                        <ValidationProvider name="Description (Bn)" vid="description_bn" rules="required">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="6"
                                                                label-for="description_bn"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('social_service.description_bn')}} <span class="text-danger">*</span>
                                                                </template>
                                                                <b-form-input
                                                                    id="description_bn"
                                                                    v-model="rehabilitation.description_bn"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                ></b-form-input>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="6"  sm="12">
                                                        <ValidationProvider name="Description (En)" vid="description" rules="required">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="6"
                                                                label-for="description"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('social_service.description_en')}} <span class="text-danger">*</span>
                                                                </template>
                                                                <b-form-input
                                                                    id="description"
                                                                    v-model="rehabilitation.description"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                ></b-form-input>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="6"  sm="12">
                                                        <ValidationProvider name="Service Cost Details (Bn)" vid="cost_detail_bn">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="6"
                                                                label-for="cost_detail_bn"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('social_service.service_cost_desc_bn')}}
                                                                </template>
                                                                <b-form-input
                                                                    id="cost_detail_bn"
                                                                    v-model="rehabilitation.cost_detail_bn"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                ></b-form-input>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="6"  sm="12">
                                                        <ValidationProvider name="Service Cost Details (En)" vid="cost_detail">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="6"
                                                                label-for="cost_detail"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('social_service.service_cost_desc_en')}}
                                                                </template>
                                                                <b-form-input
                                                                    id="cost_detail"
                                                                    v-model="rehabilitation.cost_detail"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                ></b-form-input>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="6"  sm="12">
                                                        <ValidationProvider name="Rehabilitation Date" vid="service_date" rules="required">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="6"
                                                                label-for="service_date"
                                                                slot-scope="{ valid, errors }"
                                                            >
                                                            <template v-slot:label>
                                                                {{$t('social_service.rehabilitation_date')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-input
                                                            id="service_date"
                                                            v-model="rehabilitation.service_date"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="6"  sm="12">
                                                        <ValidationProvider name="Service Cost Amount" vid="cost_amount" rules="">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="6"
                                                                label-for="cost_amount"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('social_service.service_cost_amount')}}
                                                                </template>
                                                                <b-form-input
                                                                    type="number"
                                                                    id="cost_amount"
                                                                    v-model="rehabilitation.cost_amount"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                ></b-form-input>
                                                                <div class="invalid-feedback">
                                                                    {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <!-- <b-col lg="6"  sm="12">
                                                        <ValidationProvider name="Social Service Officer Name (Bn)" vid="officer_name_bn" rules="required">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="6"
                                                                label-for="officer_name_bn"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('social_service.service_odc_name_bn')}} <span class="text-danger">*</span>
                                                                </template>
                                                                <b-form-input
                                                                    id="officer_name_bn"
                                                                    v-model="rehabilitation.officer_name_bn"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                ></b-form-input>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="6"  sm="12">
                                                        <ValidationProvider name="Social Service Officer Name (En)" vid="officer_name" rules="required">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="6"
                                                                label-for="officer_name"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('social_service.service_odc_name_en')}} <span class="text-danger">*</span>
                                                                </template>
                                                                <b-form-input
                                                                    id="officer_name"
                                                                    v-model="rehabilitation.officer_name"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                ></b-form-input>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="6"  sm="12">
                                                        <ValidationProvider name="Comment (Bn)" vid="comments_bn" rules="required">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="6"
                                                                label-for="comments_bn"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('social_service.coment_bn')}} <span class="text-danger">*</span>
                                                                </template>
                                                                <b-form-input
                                                                    id="comments_bn"
                                                                    v-model="rehabilitation.comments_bn"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                ></b-form-input>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="6"  sm="12">
                                                        <ValidationProvider name="Comment (En)" vid="comments" rules="required">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="6"
                                                                label-for="comments"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('social_service.coment_en')}} <span class="text-danger">*</span>
                                                                </template>
                                                                <b-form-input
                                                                    id="comments"
                                                                    v-model="rehabilitation.comments"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                ></b-form-input>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="6" md="6" sm="6" xs="12">
                                                        <ValidationProvider name="Receipt Upload" vid="attachment">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="6"
                                                            :label="$t('social_service.attachment')"
                                                            label-for="attachment"
                                                            slot-scope="{ valid, errors }"
                                                            >
                                                            <template v-slot:label>
                                                            {{$t('social_service.recipt_upload')}}
                                                            </template>
                                                            <b-row v-if="rehabilitation.attachment">
                                                                <b-col cols="10">
                                                                    <b-form-file
                                                                    id="attachment"
                                                                    v-on:change="onFileChange2"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    ></b-form-file>
                                                                </b-col>
                                                                <b-col>
                                                                    <a :href="baseUrl + 'download-attachment?file=uploads/config/SocialService/attachmentoriginal/' + rehabilitation.attachment" title="Attachment Download"><i class="ri-download-cloud-fill"></i></a>
                                                                </b-col>
                                                            </b-row>
                                                            <b-form-file v-else
                                                            id="attachment"
                                                            v-on:change="onFileChange2"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-file>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col> -->
                                                </b-row>
                                            </b-col>
                                            <b-col lg="12" md="12" sm="12" xs="12">
                                                <b-row style="background-color: #66cc99;margin-bottom: 15px;padding: 8px 8px 8px 8px;margin-left: 0px;margin-right: 0px;">
                                                    <b-col cols="4">
                                                        <strong style="color: white;">{{ $t('social_service.document_title_bn') }}  <span class="text-danger">*</span></strong>
                                                    </b-col>
                                                    <b-col cols="4">
                                                        <strong style="color: white;">{{ $t('social_service.document_title_en') }}  <span class="text-danger">*</span></strong>
                                                    </b-col>
                                                    <b-col cols="4">
                                                        <strong style="color: white;">{{ $t('social_service.upload') }}  <span class="text-danger">*</span></strong>
                                                    </b-col>
                                                </b-row>
                                                <b-overlay :show="customAttachment.unitload" rounded="sm">
                                                    <b-row>
                                                        <b-col cols="4">
                                                            <ValidationProvider name="Document Title (Bn)" vid="document_title_bn">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="12"
                                                                    label-for="document_title_bn"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                    <b-form-input
                                                                    id="document_title_bn"
                                                                    v-model="customAttachment.document_title_bn"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    ></b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                        <b-col cols="4">
                                                            <ValidationProvider name="Document Title" vid="document_title">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="12"
                                                                    label-for="document_title"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                    <b-form-input
                                                                    id="document_title"
                                                                    v-model="customAttachment.document_title"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    ></b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                        <b-col cols="4">
                                                            <ValidationProvider name="Attachment" vid="attachment">
                                                                <b-form-group
                                                                class="row"
                                                                label-cols-sm="12"
                                                                label-for="attachment"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <b-form-file
                                                                :browse-text="browseText"
                                                                v-model="customAttachment.attachment"
                                                                v-on:change="onFileChange"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                ></b-form-file>
                                                                <div class="invalid-feedback">
                                                                    {{ errors[0] }}
                                                                </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                    </b-row>
                                                    <template v-if="multiAttachments.length > 0">
                                                        <div><p class="h5 mb-0">Uploaded Files</p></div>
                                                        <hr/>
                                                        <template v-for="(attachedFile, index) in multiAttachments">
                                                            <b-row :key="index">
                                                                <b-col cols="3">
                                                                    {{ attachedFile.document_title_bn}}
                                                                </b-col>
                                                                <b-col cols="4">
                                                                    {{ attachedFile.document_title }}
                                                                </b-col>
                                                                <b-col cols="3">
                                                                    <a :href="baseUrl + 'download-attachment?file=' + attachedFile.attachment" title="Attachment Download">{{ attachedFile.original_file_name }}</a>
                                                                </b-col>
                                                                <b-col cols="2">
                                                                    <b-button variant=" iq-bg-danger" size="sm" @click="deleteUploadedFile(attachedFile.attachment)"><i class="ri-delete-bin-line m-0"></i></b-button>
                                                                </b-col>
                                                            </b-row>
                                                            <br :key="index + 999"/>
                                                        </template>
                                                        <hr/>
                                                    </template>
                                                </b-overlay>
                                            </b-col>
                                        </b-row>
                                        <br/>
                                        <div class="row">
                                            <div class="col-sm-3"></div>
                                            <div class="col text-right">
                                                <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                                &nbsp;
                                                <b-button variant="danger" class="mr-1" @click="backToList()">{{ $t('globalTrans.cancel') }}</b-button>
                                            </div>
                                        </div>
                                    </b-form>
                                </ValidationObserver>
                            </b-col>
                        </b-row>
                    </b-overlay>
                    </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { rehabilitationStoreApi, socialPatientNewFormNoApi, rehabilitationUpdateApi, patientRegAutoDataApi, rehabilitationDeatilApi, assignUserHospitalApi } from '../../../api/routes'
import flatpickr from 'flatpickr'
import Custom from '../../../../../../store/custom'

export default {
    props: ['id', 'item'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        var officeId = this.$store.state.Auth.authUser.office_id
        if (officeId > 1) {
            this.userId = this.$store.state.Auth.authUser.user_id
            if (this.userId > 1) {
                this.getUserWiseHospital(this.userId)
            }
        } else {
            this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                this.hospitalIds.push(obj.value)
            })
            this.hospitalList = this.getHospitalList()
        }
        const id = this.$route.params.id
        if (id !== undefined && id !== 0) {
            this.getRehabilitationData(id)
            this.form_no_disabled = true
            // this.rehabilitation = tmp
        }
        if (this.$store.state.Auth.activeRoleId !== 1) {
            if (this.$store.state.Auth.authUser.is_org_admin !== 1) {
                this.getUserWiseHospital(this.userId)
                this.isDisable = true
            }
        }
    },
    mounted () {
        flatpickr('#date', {})
        flatpickr('#service_date', {})
        core.index()
    },
    data () {
        return {
            unitload: false,
            isShow: false,
            loader: false,
            form_no_disabled: false,
            isDisable: false,
            baseUrl: hospitalServiceBaseUrl,
            ItemShow: false,
            DhownloadShow: false,
            CityCorpItemShow: false,
            PauroshobaItemShow: false,
            UnionItemShow: false,
            hospitalServiceBaseUrl: hospitalServiceBaseUrl,
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            browseText: 'Add Files',
            rehabilitation: {
                id: '',
                    hos_area_type_id: 0,
                    hos_division_id: 0,
                    hos_district_id: 0,
                    hos_upazila_id: 0,
                    hos_city_corporation_id: 0,
                    hospital_id: '',
                form_no: '',
                patient_name: '',
                patient_name_bn: '',
                age: '',
                gender_id: 0,
                rehab_institute_id: 0,
                patient_category: 0,
                patient_type: 0,
                address: '',
                address_bn: '',
                division_id: 0,
                district_id: 0,
                upazila_id: 0,
                area_type_id: 0,
                city_corporation_id: 0,
                pauroshoba_id: 0,
                ward_id: 0,
                country_id: 1,
                description: '',
                description_bn: '',
                cost_detail: '',
                cost_detail_bn: '',
                service_date: '',
                officer_name: '',
                officer_name_bn: '',
                comments: '',
                comments_bn: '',
                cost_amount: '',
                attachment: '',
                items: [
                    {
                        document_title: '',
                        document_title_bn: '',
                        attachment: ''
                    }
                ],
                attachment_two: '',
                attachment2: ''
            },
            districtList: [],
            upazilaList: [],
            unionList: [],
            cityCorporationList: [],
            pauroshobaList: [],
            thanaList: [],
            wardList: [],
            multiAttachments: [],
            hospitalList: [],
            hospitalIds: [],
            userId: 0,
            customAttachment: {
                id: 0,
                document_title: null,
                document_title_bn: null,
                attachment: [],
                unitload: false
            }
        }
    },
    computed: {
        getAreaTypeList: function () {
            const objectData = Custom.wardTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.name_bn }
                } else {
                    return { value: obj.id, text: obj.name }
                }
            })
        },
        divisionList: function () {
            return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        },
        genderList: function () {
            const objectData = this.$store.state.commonObj.genderList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        patientTypeList: function () {
            const objectData = this.$store.state.HospitalDisabilityService.commonObj.patientTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        socialServiceDeliveryList: function () {
            const objectData = this.$store.state.HospitalDisabilityService.commonObj.socialServiceDeliveryList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        rehabilitationInstituteList: function () {
            const objectData = this.$store.state.HospitalDisabilityService.commonObj.rehabilitationInstituteList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        donationTypeList: function () {
            const objectData = this.$store.state.HospitalDisabilityService.commonObj.donationTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        itemCatList: function () {
            const objectData = this.$store.state.HospitalDisabilityService.commonObj.hosItemList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        serviceTypeList: function () {
            const objectData = this.$store.state.HospitalDisabilityService.commonObj.serviceTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.name_bn }
                } else {
                    return { value: obj.id, text: obj.name }
                }
            })
        },
        getHosDivisionList: function () {
            return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        },
        getHosDistrictList: function () {
            return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === this.rehabilitation.hos_division_id)
        },
        getHosCityCorporationList: function () {
            return this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === this.rehabilitation.hos_district_id)
        },
        getHosUpazillaList: function () {
            return this.$store.state.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === this.rehabilitation.hos_district_id)
        },
        getHosAreaTypeList: function () {
            const objectData = this.$store.state.commonObj.wardTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.name_bn }
                } else {
                    return { value: obj.id, text: obj.name }
                }
            })
        }
    },
    watch: {
        'rehabilitation.patient_type': function (newVal, oldVal) {
            if (this.$route.params.id > 0) {
            } else {
                if (newVal === 1) {
                    this.rehabilitation.form_no = ''
                    this.form_no_disabled = false
                } else {
                    this.getFormNo()
                }
            }
        },
        'rehabilitation.division_id': function (newVal, oldVal) {
            this.districtList = this.getDistrictList(newVal)
        },
        'rehabilitation.district_id': function (newVal, oldVal) {
            this.cityCorporationList = this.getCityCorporationList(newVal)
            this.upazilaList = this.getUpazilaList(newVal)
            this.thanaList = this.getThanaList(newVal)
        },
        'rehabilitation.upazilla_id': function (newVal, oldVal) {
            this.unionList = this.getUnionList(newVal)
            this.pauroshobaList = this.getPauroshobaList(newVal)
        },
        'rehabilitation.city_corporation_id': function (newVal, oldVal) {
            this.wardList = this.getWardListByCityCorportaion(newVal)
        },
        'rehabilitation.union_id': function (newVal, oldVal) {
            this.wardList = this.getWardListByUnion(newVal)
        },
        'rehabilitation.pauroshoba_id': function (newVal, oldVal) {
            this.wardList = this.getWardListByPauroshoba(newVal)
        },
        'rehabilitation.hos_area_type_id': function () {
            this.hospitalList = this.getHospitalList()
        },
        'rehabilitation.hos_division_id': function () {
            this.hospitalList = this.getHospitalList()
        },
        'rehabilitation.hos_district_id': function () {
            this.hospitalList = this.getHospitalList()
        },
        'rehabilitation.hos_upazila_id': function () {
            this.hospitalList = this.getHospitalList()
        },
        'rehabilitation.hos_city_corporation_id': function () {
            this.hospitalList = this.getHospitalList()
        },
        'rehabilitation.hospital_id': function (newVal, oldVal) {
        if (this.$route.params.id > 0) {
            } else {
                if (newVal === 1) {
                    this.rehabilitation.form_no = ''
                    this.form_no_disabled = false
                } else {
                    this.getFormNo()
                }
            }
        if (newVal && oldVal !== 0) {
            this.rehabilitation.department_id = 0
            this.rehabilitation.hos_ward_id = 0
            const hospital = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.find(item => item.value === parseInt(newVal))
            this.rehabilitation.hos_area_type_id = hospital.area_type_id ? hospital.area_type_id : 0
            this.rehabilitation.hos_division_id = hospital.division_id ? hospital.division_id : 0
            this.rehabilitation.hos_district_id = hospital.district_id ? hospital.district_id : 0
            this.rehabilitation.hos_upazila_id = hospital.upazilla_id ? hospital.upazilla_id : 0
            this.rehabilitation.hos_city_corporation_id = hospital.city_corporation_id ? hospital.city_corporation_id : 0
            }
            if (newVal < 1) {
            this.rehabilitation.hos_area_type_id = 0
            this.rehabilitation.hos_division_id = 0
            this.rehabilitation.hos_district_id = 0
            this.rehabilitation.hos_upazila_id = 0
            this.rehabilitation.hos_city_corporation_id = 0
            }
        }
    },
    methods: {
        async getUserWiseHospital (userId) {
        const params = Object.assign({ user_id: userId })
        const result = await RestApi.getData(hospitalServiceBaseUrl, assignUserHospitalApi, params)
        if (result.success) {
                this.hospitalIds = result.data
        } else {
              this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                  this.hospitalIds.push(obj.value)
              })
        }
        // this.loadData()
        this.hospitalList = this.getHospitalList()
        if (this.hospitalList.length && this.isDisable) {
            this.rehabilitation.hospital_id = this.hospitalList[0].value
        }
    },
    getHospitalList () {
        let hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
        if (this.hospitalIds.length > 0) {
        hospitalList = hospitalList.filter((p) => this.hospitalIds.includes(p.value))
        }
        this.hospitalLoad = false
        if (this.rehabilitation.hos_area_type_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.area_type_id === this.rehabilitation.hos_area_type_id)
        }

        if (this.rehabilitation.hos_category > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.category === this.rehabilitation.hos_category)
        }

        if (this.rehabilitation.hos_division_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.division_id === this.rehabilitation.hos_division_id)
        }

        if (this.rehabilitation.hos_district_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.district_id === this.rehabilitation.hos_district_id)
        }

        if (this.rehabilitation.hos_city_corporation_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.city_corporation_id === this.rehabilitation.hos_city_corporation_id)
        }
        return hospitalList
    },
    getAreaTypeData (typeId) {
        this.ItemShow = true
        if (typeId === 1) {
            this.CityCorpItemShow = true
            this.PauroshobaItemShow = false
            this.UnionItemShow = false
        } else if (typeId === 2) {
            this.CityCorpItemShow = false
            this.PauroshobaItemShow = true
            this.UnionItemShow = false
        } else if (typeId === 3) {
            this.CityCorpItemShow = false
            this.PauroshobaItemShow = false
            this.UnionItemShow = true
        }
        if (!this.$route.query.id) {
        //   this.rehabilitation.patient.city_corporation_id = 0
        //   this.rehabilitation.patient.pauroshoba_id = 0
        //   this.rehabilitation.patient.ward_id = 0
        //   this.rehabilitation.patient.country_id = 1
        //   this.rehabilitation.patient.division_id = 0
        //   this.rehabilitation.patient.district_id = 0
        //   this.rehabilitation.patient.upazilla_id = 0
        //   this.rehabilitation.patient.thana_id = 0
        //   this.rehabilitation.patient.union_id = 0
        }
    },
        // async getUserWiseHospital (userId) {
        //     const params = Object.assign({ user_id: userId })
        //     const result = await RestApi.getData(hospitalServiceBaseUrl, assignUserHospitalApi, params)
        //     if (result.success) {
        //             this.hospitalIds = result.data
        //     } else {
        //         this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
        //             this.hospitalIds.push(obj.value)
        //         })
        //     }
        //     this.hospitalList = this.getHospitalList()
        // },
        // getHospitalList () {
        //     let hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
        //     if (this.hospitalIds.length > 0) {
        //     hospitalList = hospitalList.filter((p) => this.hospitalIds.includes(p.value))
        //     }
        //     this.hospitalLoad = false

        //     return hospitalList
        // },
        // getAreaTypeData (typeId) {
        //     this.ItemShow = true
        //     if (typeId === 1) {
        //         this.CityCorpItemShow = true
        //         this.PauroshobaItemShow = false
        //         this.UnionItemShow = false
        //     } else if (typeId === 2) {
        //         this.CityCorpItemShow = false
        //         this.PauroshobaItemShow = true
        //         this.UnionItemShow = false
        //     } else if (typeId === 3) {
        //         this.CityCorpItemShow = false
        //         this.PauroshobaItemShow = false
        //         this.UnionItemShow = true
        //     }
        //     if (!this.$route.query.id) {
        //     this.rehabilitation.city_corporation_id = 0
        //     this.rehabilitation.pauroshoba_id = 0
        //     this.rehabilitation.ward_id = 0
        //     this.rehabilitation.country_id = 1
        //     this.rehabilitation.division_id = 0
        //     this.rehabilitation.district_id = 0
        //     this.rehabilitation.upazilla_id = 0
        //     this.rehabilitation.thana_id = 0
        //     this.rehabilitation.union_id = 0
        //     }
        // },
        async getRehabilitationData (id) {
            this.unitload = true
            const result = await RestApi.getData(hospitalServiceBaseUrl, rehabilitationDeatilApi + '/' + id)
            // const tmpData = this.$store.state.list.find(item => item.id === this.id)
            this.getFormIdByData2(result.data.form_no)
            // const formData = JSON.parse(JSON.stringify(tmpData))
            const formData = result.data
            this.multiAttachments = formData.social_service_documents
            this.rehabilitation = formData
            return formData
        },
        async storeUpdateData () {
            if (!this.validateAttachment()) {
                return
            }
            this.unitload = true
            let result = null
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            var formData = new FormData()
            Object.keys(this.rehabilitation).map(key => {
                if (key === 'attachment') {
                    formData.append(key, this.rehabilitation.attachment2)
                } else {
                    formData.append(key, this.rehabilitation[key])
                }
            })
            formData.append('multi_attachments', JSON.stringify(this.multiAttachments))
            if (this.rehabilitation.id) {
                formData.append('_method', 'PUT')
                result = await RestApi.postData(hospitalServiceBaseUrl, `${rehabilitationUpdateApi}/${this.rehabilitation.id}`, formData, config)
            } else {
                result = await RestApi.postData(hospitalServiceBaseUrl, rehabilitationStoreApi, formData, config)
            }
            if (result.success) {
                this.$toast.success({
                title: this.$t('globalTrans.success'),
                message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                color: '#D6E09B'
                })
                this.unitload = false
                this.$router.push({ path: '/hospital-disability-service/social-service/rehabilitation' })
            } else {
                this.unitload = false
                this.$refs.form.setErrors(result.errors)
            }
            this.unitload = false
        },
        remove (key) {
            this.rehabilitation.items.splice(key, 1)
        },
        async getFormIdByData2 (fNo) {
            this.unitload = true
            const result = await RestApi.getData(hospitalServiceBaseUrl, patientRegAutoDataApi + '/' + fNo)
            if (result.success) {
                this.getAreaTypeData(result.data.area_type_id)
                this.rehabilitation.form_no = result.data.form_no
                this.rehabilitation.patient_name = result.data.patient_name
                this.rehabilitation.patient_name_bn = result.data.patient_name_bn
                this.rehabilitation.gender_id = result.data.gender_id
                this.rehabilitation.age = result.data.age
                this.rehabilitation.area_type_id = result.data.area_type_id
                this.rehabilitation.division_id = result.data.division_id
                this.rehabilitation.district_id = result.data.district_id
                this.rehabilitation.upazila_id = result.data.upazilla_id
                this.rehabilitation.address = result.data.address
                this.rehabilitation.address_bn = result.data.address_bn
                this.form_no_disabled = true
            } else {
                if (this.rehabilitation.patient_type === 1) {
                    this.isShow = true
                } else {
                    this.isShow = false
                }
            }
            this.unitload = false
        },
        searchFormNoData () {
            if (this.rehabilitation.auto_id && this.rehabilitation.patient_type === 1 && !this.$route.params.id) {
                this.getFormIdByData(this.rehabilitation.auto_id)
            }
        },
        async getFormNo () {
            if (this.rehabilitation.patient_type === 2) {
                this.unitload = true
                const params = Object.assign({}, { hospital_id: this.rehabilitation.hospital_id })
                const result = await RestApi.getData(hospitalServiceBaseUrl, socialPatientNewFormNoApi, params)
                if (result.success) {
                        this.rehabilitation.form_no = result.form_no
                        this.rehabilitation.auto_id = result.auto_id
                        this.form_no_disabled = true
                }
                this.unitload = false
            } else {
                this.rehabilitation.form_no = ''
                this.form_no_disabled = false
            }
        },
        async getFormIdByData (formNo) {
            this.unitload = true
            const result = await RestApi.getData(hospitalServiceBaseUrl, patientRegAutoDataApi + '/' + formNo)
            if (result.success) {
                this.getAreaTypeData(result.data.area_type_id)
                this.rehabilitation.patient_name = result.data.patient_name
                this.rehabilitation.patient_name_bn = result.data.patient_name_bn
                this.rehabilitation.gender_id = result.data.gender_id
                this.rehabilitation.area_type_id = result.data.area_type_id
                this.rehabilitation.age = result.data.age
                this.rehabilitation.division_id = result.data.division_id
                this.rehabilitation.form_no = result.data.form_no
                this.rehabilitation.district_id = result.data.district_id
                this.rehabilitation.upazila_id = result.data.upazilla_id
                this.rehabilitation.address = result.data.address
                this.rehabilitation.address_bn = result.data.address_bn
            } else {
                if (this.rehabilitation.patient_type === 1) {
                    this.isShow = true
                } else {
                    this.isShow = false
                }
                this.$toast.error({
                    title: 'Error',
                    message: 'Your Given Form No not Found!'
                })
            }
            this.unitload = false
        },
        async onFileChange (e) {
            if (!this.validateFileUploadAssciatedFields()) {
                return
            }
            this.customAttachment.unitload = true
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            var formData = new FormData()
            formData.append('custom_file', e.target.files[0])
            const result = await RestApi.postData(hospitalServiceBaseUrl, '/file-upload', formData, config)
            if (result.success) {
                this.multiAttachments.push({
                    original_file_name: result.data.originalFileName,
                    attachment: result.data.fileFullPath,
                    document_title: this.customAttachment.document_title,
                    document_title_bn: this.customAttachment.document_title_bn
                })
                this.customAttachment = Object.assign({}, {
                    document_title: null,
                    document_title_bn: null,
                    attachment: [],
                    unitload: false
                })
            }
        },
        validateFileUploadAssciatedFields () {
            let errors = {}
            if (this.customAttachment.document_title === null || this.customAttachment.document_title === '') {
                errors = Object.assign({}, errors, { document_title: ['Document tile field is required'] })
            }
            if (this.customAttachment.document_title_bn === null || this.customAttachment.document_title_bn === '') {
                errors = Object.assign({}, errors, { document_title_bn: ['Document tile (Bn) field is required'] })
            }
            if (Object.keys(errors).length > 0) {
                this.$refs.form.setErrors(errors)
                this.customAttachment.attachment = []
                return false
            }
            return true
        },
        validateAttachment () {
            if (this.multiAttachments.length === 0) {
                const errors = {
                    document_title: ['Document tile field is required'],
                    document_title_bn: ['Document tile (bn) field is required'],
                    attachment: ['Attachment field is required']
                }
                this.$refs.form.setErrors(errors)
                return false
            }
            return true
        },
        async deleteUploadedFile (fileName) {
            this.customAttachment.unitload = true
            const result = await RestApi.deleteData(hospitalServiceBaseUrl, '/delete-uploaded-file', { file_name: fileName })
            this.customAttachment.unitload = false
            if (!result.success) {
                this.$toast.error({
                    title: 'Error',
                    message: 'Failed to delete file. Please, try again.'
                })
                return
            }
            const tmp = this.multiAttachments.filter(item => {
                return item.attachment !== fileName
            })
            this.multiAttachments = tmp
        },
        onFileChange2 (e) {
            this.rehabilitation.attachment2 = e.target.files[0]
        },
        getDistrictList (divisionId = null) {
            const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)

            if (divisionId) {
                return districtList.filter(district => district.division_id === divisionId)
            }

            return districtList
        },
        getUpazilaList (districtId = null) {
            const upazilaList = this.$store.state.commonObj.upazilaList.filter(item => item.status === 0)

            if (districtId) {
                return upazilaList.filter(upazila => upazila.district_id === districtId)
            }

            return upazilaList
        },
        getUnionList (upazilaId = null) {
            const unionList = this.$store.state.commonObj.unionList.filter(item => item.status === 0)
            if (upazilaId) {
                return unionList.filter(union => union.upazilla_id === upazilaId)
            }

            return unionList
        },
        getThanaList (districtId = null) {
            const thanaList = this.$store.state.commonObj.upazilaList.filter(item => item.status === 0)
            if (districtId) {
                return thanaList.filter(upazila => upazila.district_id === districtId)
            }
            return thanaList
        },
        getCityCorporationList (districtId) {
            const objectData = this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        getPauroshobaList (upazillaId = null) {
            const objectData = this.$store.state.commonObj.pauroshobaList.filter(item => item.upazilla_id === upazillaId)
            if (upazillaId) {
                return objectData.map((obj, key) => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: obj.value, text: obj.text_bn }
                    } else {
                        return { value: obj.value, text: obj.text_en }
                    }
                })
            }
        },
        getWardListByCityCorportaion (cityCorpId) {
            const objectData = this.$store.state.commonObj.wardList
            const wardObjectList = objectData.filter(item => item.city_corporation_id === cityCorpId && item.status === 0)
            return wardObjectList.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text }
                }
            })
        },
        getWardListByPauroshoba (pauroshobaId) {
            const objectData = this.$store.state.commonObj.wardList
            const wardObjectList = objectData.filter(item => item.pauroshoba_id === pauroshobaId && item.division_id === this.rehabilitation.division_id && item.district_id === this.rehabilitation.district_id && item.upazilla_id === this.rehabilitation.upazilla_id && item.status === 0)
            return wardObjectList.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text }
                }
            })
        },
        getWardListByUnion (unionId) {
            const objectData = this.$store.state.commonObj.wardList
            const wardObjectList = objectData.filter(item => item.union_id === unionId && item.division_id === this.rehabilitation.division_id && item.district_id === this.rehabilitation.district_id && item.upazilla_id === this.rehabilitation.upazilla_id && item.status === 0)
            return wardObjectList.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text }
                }
            })
        },
        backToList () {
            this.$router.push({ path: '/hospital-disability-service/social-service/rehabilitation' })
        }
    }
}

</script>
<style scoped>
  .txtCol{color: black;}
  hr {
      margin-top: 0px !important;
  }
</style>
